let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("Wowvf"), load("hhss7"), load("b6JBs")]).then(() => parcelRequire('g3Wvh'));